<div id="headerWrapper"
    class="syndicated-header-wrapper"
    [@headerState]="stateName"
    (@headerState.done)="headerStateDone($event)">
    <script-loader [src]="syndicatedHeaderUrl"></script-loader>
</div>
